import type {ReactNode} from 'react';

/** Safely render the small Markdown subset supported by the owner-provided
 * Helm room description: paragraph breaks, bold/italic, headings and lists.
 * JSX escapes all literal text. No raw HTML or untrusted injected markup.
 */
function inlineMarkdown(line:string,keyPrefix:string):ReactNode[]{
  const tokens=/(\*\*[^*\n]+\*\*|__[^_\n]+__|\*[^*\n]+\*|_[^_\n]+_|\[[^\]\n]+\]\(https?:\/\/[^\s)]+\))/g;
  const out:ReactNode[]=[];
  let prior=0,index=0;
  for(const match of line.matchAll(tokens)){
    const at=match.index??0;
    if(at>prior)out.push(line.slice(prior,at));
    const raw=match[0],key=keyPrefix+'-'+index++;
    if(raw.startsWith('**')||raw.startsWith('__'))
      out.push(<strong key={key}>{raw.slice(2,-2)}</strong>);
    else if(raw.startsWith('*')||raw.startsWith('_'))
      out.push(<em key={key}>{raw.slice(1,-1)}</em>);
    else{
      const mark=/^\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)$/.exec(raw);
      if(mark)out.push(<a key={key} href={mark[2]}
        target="_blank" rel="noopener noreferrer">{mark[1]}</a>);
      else out.push(raw);
    }
    prior=at+raw.length;
  }
  if(prior<line.length)out.push(line.slice(prior));
  return out;
}
export function RoomFormattedText({content}:{content:string}){
  const normalized=content.replace(/\r\n?/g,'\n').trim();
  if(!normalized)return null;
  const blocks=normalized.split(/\n\s*\n/);
  return <div className="ecfs-room-formatted-text">
    {blocks.map((block,index)=>{
      const lines=block.split('\n');
      if(lines.every(line=>/^\s*[-*]\s+/.test(line)))
        return <ul key={index}>{lines.map((line,n)=><li key={n}>
          {inlineMarkdown(line.replace(/^\s*[-*]\s+/,''),index+'-'+n)}
        </li>)}</ul>;
      if(lines.length===1&&/^#{1,4}\s+/.test(lines[0])){
        return <h4 key={index}>{inlineMarkdown(lines[0].replace(/^#{1,4}\s+/,''),String(index))}</h4>;
      }
      return <p key={index}>{lines.map((line,n)=><span key={n}>
        {n>0&&<br/>}{inlineMarkdown(line,index+'-'+n)}
      </span>)}</p>;
    })}
  </div>;
}
